// extracted by mini-css-extract-plugin
module.exports = {"addRoleBtn":"ob_JBP7nL","addCircleIcon":"ob_1ylzqt","sticky":"ob_boRNHJ","redMaskIcon":"ob_MgISYp","stickyIcon":"ob_LPTzdN"};